import InvoicesHeader from './InvoicesHeader';

export default InvoicesHeader;
